// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".factor-levels{-moz-column-count:3;column-count:3}", "",{"version":3,"sources":["webpack://./resources/js/components/Chart/ContextMenu/Factors.vue"],"names":[],"mappings":"AACA,eACI,mBAAA,CAAA,cAAJ","sourcesContent":["\n.factor-levels {\n    column-count: 3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
